module.exports = __webpack_public_path__ + "static/media/interativoAtivo 1.a084a12a.svg";